import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {CardDataController} from '@colonist/game-card-types'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {getMerchantImageNameForPlayer, Sprites} from '../UIGameImageDictionary'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CardEnum, MechanicMerchantState} from '@colonist/game-states'

export class UIGamePlayerInformationMerchantView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private playerInformation: UIGamePlayerInformationView
    private merchantIconView: SpriteView
    private readonly merchantState: MechanicMerchantState

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView, merchantState: MechanicMerchantState) {
        this.uiGameManager = uiGameManager
        this.playerInformation = playerInformation
        this.merchantState = merchantState
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.initPlayerInformationView()
        this.initMerchantIconView()

        this.resetMerchantIconPlayerInformationView()
    }

    private initMerchantIconView() {
        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        const isMyColor = this.playerInformation.player.color == bottomPlayerColor

        this.merchantIconView = isMyColor ? this.getMyMerchantIconView() : this.getOpponentMerchantIconView()

        const merchantCardData = CardDataController.getCardDataForCard(CardEnum.ProgressCardTradeMerchant)

        if(merchantCardData == undefined) {
            const merchantIconTipTitle: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
            const merchantIconTipBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
            this.merchantIconView.setTip(merchantIconTipTitle, [merchantIconTipBody])
        } else {
            const {tipTitle, tipBody} = merchantCardData
            this.merchantIconView.setTip(tipTitle, [tipBody])
        }
    }

    private initPlayerInformationView() {
        const newPlayerInformation = this.uiGameManager.playersController.playerInformationViews.find((playerInformation) => (
            playerInformation.player.color == this.playerInformation.player.color
        ))
        if(newPlayerInformation == undefined) return
        this.playerInformation = newPlayerInformation
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MerchantStateUpdated: this.merchantStateUpdated(); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            default: break
        }
    }

    private getMyMerchantIconView(): SpriteView {
        const merchantH = this.playerInformation.specialIconView.height * 0.85
        const merchantTextureName = getMerchantImageNameForPlayer(this.playerInformation.player.color)
        const merchantTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites[merchantTextureName])
        const isUserOnPortraitMode = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const merchantXPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.width - merchantH : 0
        const merchantYPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.height - merchantH : 0

        const merchantIcon = new SpriteView(merchantXPosition, merchantYPosition, merchantH, merchantH, this.playerInformation.specialIconView, merchantTexture)
        return merchantIcon
    }

    private getOpponentMerchantIconView(): SpriteView {
        const isUserOnPortraitMode = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const merchantW = isUserOnPortraitMode ? this.playerInformation.specialIconView.height * 0.9 : this.playerInformation.specialIconView.width * 0.85
        const merchantTextureName = getMerchantImageNameForPlayer(this.playerInformation.player.color)
        const merchantTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites[merchantTextureName])
        const merchantXPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.width - merchantW * 1.1 : 0
        const merchantYPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.height - merchantW : this.playerInformation.specialIconView.height * 0.05

        const merchantIcon = new SpriteView(merchantXPosition, merchantYPosition, merchantW, merchantW, this.playerInformation.specialIconView, merchantTexture)
        return merchantIcon
    }

    private onCanvasResize() {
        this.initPlayerInformationView()
        this.initMerchantIconView()
        this.merchantStateUpdated()
    }

    private merchantStateUpdated() {
        this.resetMerchantIconPlayerInformationView()

        if(this.merchantState.owner != this.playerInformation.player.color) return

        if(UIUtilsEjsVariables.isUserOnMobileApp) {
            this.playerInformation.specialIconView.addChild(this.merchantIconView)
            return
        }

        this.playerInformation.specialIconView.addSpriteView(this.merchantIconView)
    }

    private resetMerchantIconPlayerInformationView() {
        if(this.merchantIconView == undefined) return
        if(this.merchantIconView.parent == undefined) return
        this.playerInformation.specialIconView.removeSpriteView(this.merchantIconView)
    }
}
